import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { motion } from 'motion/react';
import { Util, Backdrop, FocusTrap } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { useEventListener } from '@grandvisionhq/utils';
import Buttons from './components/Buttons.js';
import Header from './components/Header.js';
import Menu from './components/Menu.js';
import SubMenu from './components/SubMenu.js';

/**
 * TODO:
 *
 * CTA buttons should be configurable as "persistent" buttons so it can be shown in a submenu when needed
 * CTA buttons should be configurable as sticky so it either scrolls out of view or stays on top
 *
 * Allow for different menu items based on device. (Normalize menu items data too)
 *
 * Right now a hardcoded my-account css hack is implemented. (existing code)
 *    &--my-account {
 *      display: none;
 *    }
 */ const siteNavContainer = {
    open: {
        x: '0%',
        transition: {
            ease: 'easeInOut',
            duration: 0.3
        },
        opacity: 1
    },
    closed: {
        x: '-100%',
        transition: {
            ease: 'easeInOut',
            duration: 0.3
        }
    }
};
const SiteNavMobile = ({ ctaItems , countrySwitcherOptions , menuItems , routes , renderCartButton , renderWishlistMenuItem , ordersUrl  })=>{
    const { getLabel  } = useIntl();
    const navLabel = getLabel('common.screenreader.siteNavigationMobile', {
        hideLabelKey: true
    });
    const [isOpen, setIsOpen] = React.useState(false);
    const [activeSubMenu, setActiveSubMenu] = React.useState('');
    const firstMenuRef = React.useRef(null);
    const siteNavContainerRef = React.useRef(null);
    const handler = React.useCallback(()=>{
        setIsOpen(true);
    }, []);
    useEventListener('sitenav.open', handler);
    React.useEffect(()=>{
        if (isOpen) {
            Util.lockScroll();
            return ()=>{
                Util.unlockScroll();
                setActiveSubMenu('');
            };
        }
    }, [
        isOpen
    ]);
    const hideSiteNav = React.useCallback(()=>{
        setIsOpen(false);
    }, []);
    const hideSubMenu = React.useCallback((focusFirstElement = false)=>{
        setActiveSubMenu('');
        if (focusFirstElement) {
            setTimeout(()=>{
                var ref;
                return (ref = firstMenuRef.current) === null || ref === void 0 ? void 0 : ref.focus();
            }, 50);
        }
    }, [
        setActiveSubMenu
    ]);
    const subMenus = React.useMemo(()=>menuItems.filter((item)=>item.childMenuItems
        ).map((item)=>[
                item.label,
                item.childMenuItems
            ]
        )
    , [
        menuItems
    ]);
    const keyUp = React.useCallback((e)=>{
        if (e.key === 'Escape') hideSiteNav();
    }, [
        hideSiteNav
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Backdrop, {
        className: "site-nav-mobile__backdrop",
        isVisible: isOpen,
        onClick: hideSiteNav
    }), /*#__PURE__*/ React.createElement(FocusTrap, {
        active: isOpen,
        focusTrapOptions: {
            allowOutsideClick: true,
            escapeDeactivates: false
        }
    }, /*#__PURE__*/ React.createElement(motion.nav, swcHelpers.extends({
        animate: isOpen ? 'open' : 'closed',
        initial: "closed",
        className: classnames('site-nav-mobile', {
            'site-nav-mobile--open': isOpen
        }),
        variants: siteNavContainer,
        ref: siteNavContainerRef,
        onKeyUp: keyUp,
        "aria-hidden": !isOpen
    }, navLabel && {
        'aria-label': navLabel
    }), /*#__PURE__*/ React.createElement(Header, {
        activeSubMenu: activeSubMenu,
        countrySwitcherOptions: countrySwitcherOptions,
        backLabel: getLabel('common.actions.previous'),
        closeLabel: getLabel('common.actions.close'),
        hideSiteNav: hideSiteNav,
        hideSubMenu: hideSubMenu,
        isOpen: isOpen,
        renderCartButton: renderCartButton,
        renderWishlistMenuItem: renderWishlistMenuItem,
        ordersUrl: ordersUrl,
        routes: routes
    }), /*#__PURE__*/ React.createElement("div", {
        className: "site-nav-mobile__content"
    }, /*#__PURE__*/ React.createElement(Menu, {
        active: !activeSubMenu,
        menuItems: menuItems,
        onItemClick: setActiveSubMenu,
        firstMenuRef: firstMenuRef,
        isOpen: isOpen
    }, /*#__PURE__*/ React.createElement(Buttons, {
        items: ctaItems,
        active: !activeSubMenu && isOpen
    })), subMenus.map(([label, subMenuItems])=>/*#__PURE__*/ React.createElement(SubMenu, {
            key: label,
            active: activeSubMenu === label,
            menuItems: subMenuItems,
            hideSubMenu: hideSubMenu
        })
    )))));
};

export { SiteNavMobile as default };
//# sourceMappingURL=SiteNavMobile.js.map
